import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// @material-ui/icons

// React icons
import { FaLinkedin } from 'react-icons/fa';
// core components

import Collapse from '@material-ui/core/Collapse';

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";

import blogStyle from "assets/jss/material-kit-react/views/landingPageSections/blogStyle.jsx";

import whyCards from "data/why-cards.json";
import GirlAndBull from "components/Image/GirlAndBull.jsx";
import GirlAndNyse from "components/Image/GirlAndNyse.jsx";
import StockChart from "components/Image/StockChart.jsx";

class BlogSection extends React.Component {
  render() {
    const { classes } = this.props;
    const imageClasses = classNames(
      classes.imgRaised,
      classes.imgFluid
    );
    const imageMap = {
      GirlAndBull: <GirlAndBull/>,
      GirlAndNyse: <GirlAndNyse/>,
      StockChart: <StockChart/>
    };

    return (
      <div id="team" className={classes.section}>
        <GridContainer justify="center">
        <GridItem xs={12}>
        <h2 className={classes.title}>
        <span className={classes.inlineBlock}>Our story.&nbsp;</span><span className={classes.inlineBlock}>Our why.</span>
        </h2>
        </GridItem>
        </GridContainer>
        <div>
          <GridContainer>
          {whyCards.map(member => (
            <GridItem xs={12} sm={6} md={4}>
              <Card plain className={classes.card}>
                <GridItem xs={12} className={classes.itemGrid}>
                  {imageMap[member.img.image]}
                </GridItem>
                <h4 className={classes.cardTitle}>
                  <span dangerouslySetInnerHTML={{__html: `${member.title}`}}/>                  <br />
                  <small className={classes.smallTitle}>{member.subtitle}</small>
                </h4>
                <CardBody className={classes.cardBody} style={{minHeight: "10rem"}}>
                  <p className={classes.description} dangerouslySetInnerHTML={{__html: `${member.text}`}}></p>
                </CardBody>
              </Card>
            </GridItem>))}
          </GridContainer>
        </div>
      </div>
    );
  }
}

export default withStyles(blogStyle)(BlogSection);